import { css } from '@emotion/react';
import { Stack, styled } from '@mui/material';

import { LayerControl } from '@/components/map/controls/LayerControl';
import { MapSearchAutocomplete } from '@/components/map/controls/MapSearchAutocomplete';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

const Root = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    z-index: 1;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing(2)};
    position: absolute;
    width: calc(100% - ${theme.spacing(4)});
    top: ${theme.spacing(2)};
    left: ${theme.spacing(2)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      width: inherit;
    }
  `,
);

export function MenuBar() {
  return (
    <Root>
      <MapSearchAutocomplete />
      <LayerControl />
    </Root>
  );
}
